<article 
  class="points__point"
  [class.points__point--to-delete]="isPointToDelete()"
  [class.points__point--to-replace]="isPointToReplace()"
  [class.points__point--to-add]="isPointToAddNew()"
>
  @if (!isImgError) {
    <header class="point__header">
      @defer (on viewport) { 
        <img 
          [src]="img() || '/assets/imgs/default-custom-route-img.webp'" 
          [attr.alt]="('Imagen' | translate) + ' ' + title()"
          (error)="handleImgError()"
        >
      } @placeholder {
        <img 
          src="/assets/imgs/default-custom-route-img.webp" 
          [attr.alt]="('Imagen' | translate) + ' ' + title()"
        >
      }
    </header>
  } 
  
  <main class="point__main">
    <h2 class="point__title ci-paragraph-p1-semibold">
      {{ title() | translate }}
    </h2>
    
    <div class="point__info">
      <ci-icon
        class="point__icon"
        name="calendar"
        type="svg"
      ></ci-icon>
      
      <span class="info__text ci-footer-semibold">
        Día {{ dayToShowIndex + 1 }} - {{ startDate() | date: 'HH:mm'}}
      </span>
    </div>
    
    <div class="point__info">
      <ci-icon
        class="info__icon"
        name="duracion"
        type="svg"
      ></ci-icon>
      
      <span class="info__text ci-footer-semibold">
        {{ durationMinutes() | duration }}
      </span>
    </div>
  </main>
  
  <footer class="point__footer">
    <ci-icon
      class="point__icon"
      name="more-portrait"
      type="svg"
    ></ci-icon>
  </footer>
</article>